import { Flag } from 'lucide-react'
import { cn } from '@/lib/cn'

/**
 * A flag says "come back to this": it needs another look, or it is waiting on
 * the client. Like a favorite it is independent of the verdict — a flagged item
 * can be pending, approved or rejected — and unlike one it is shared by the
 * whole team (`content.entity_marker`, migrations/020).
 */
export function FlagToggle({
  flagged,
  onChange,
  className,
}: {
  flagged: boolean
  onChange: (next: boolean) => void
  className?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={flagged}
      aria-label={flagged ? 'Remove flag' : 'Flag for follow-up'}
      title={flagged ? 'Flagged for follow-up' : 'Flag for follow-up'}
      onClick={(e) => {
        e.stopPropagation()
        onChange(!flagged)
      }}
      className={cn(
        'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-[4px]',
        'transition-colors hover:bg-surface-sunk',
        flagged ? 'text-brand-red' : 'text-ink-faint',
        className,
      )}
    >
      <Flag size={14} fill={flagged ? 'currentColor' : 'none'} aria-hidden />
    </button>
  )
}
